import { z } from 'zod';

export const DocumentSearchToolName = 'documentSearch';

/**
 * DocumentSearch tool definition
 */
export const documentSearchArgsSchema = z.object({
  searchQuery: z
    .string()
    .describe(
      'Complete search query or user question. Use natural language - the system handles both semantic and keyword matching internally',
    ),
  context: z
    .string()
    .nullable()
    .optional()
    .default(null)
    .describe(
      'Additional context from conversation or previous tool results to improve search accuracy',
    ),
});

export const documentSearchContentSchema = z.object({
  content: z.string().describe('Search results or response content.'),
  error: z
    .string()
    .optional()
    .describe('Error message if tool execution failed.'),
});

export type DocumentSearchArgs = z.infer<typeof documentSearchArgsSchema>;
export type DocumentSearchContent = z.infer<typeof documentSearchContentSchema>;
